module.exports = __webpack_public_path__ + "img/3c-store-distribution.81640434.png";